
import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./styles.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import FloatingCall from "./components/FloatingCall";
import { Route, Routes } from "react-router-dom";
import Home from "./Home";
import { PageNotFound } from "./components/PageNotFound";
import PrivacyPolicy, { Privacypolicy } from "./components/PrivacyPolicies";
import USPSection from "./components/USPSection/USPSection";
import Plans from "./components/PlanCard/Plans";
import Hero from "./components/Hero";
import FeatureGrid from "./components/FeatureGrid";
import WhyChoose from "./components/WhyChoose";
import Testimonials from "./components/Testimonials";

function App() {
  return (
    <div className="app-wrapper">
      <Header />
      <Routes>
  <Route path="/" element={<Home />} />
  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
  <Route path="*" element={<PageNotFound />} />
</Routes>
      {/* <Hero />
      <FeatureGrid />
      <WhyChoose />
      <Plans />
      <USPSection />
      <Testimonials /> */}
      <FloatingCall />
      <Footer />
    </div>
  );
}

export default App;
